module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_9005.d7d2811f.png";